<template>
  <div id="app" class="cs-wrapper">
    <div class="cs-header">
      <el-row>
        <el-col :span="8" :offset="4">
          <div class="cs-logo">
            <div class="cs-logo-container">
              <img src="./assets/video-logo.png" v-if="isLogged">
            </div>
          </div>
        </el-col>
        <el-col :span="2">
          <span>&nbsp;</span>
        </el-col>
        <el-col :span="6">
          <div class="cs-userInfo" v-show="isLogged && showAdminHader">
            <a v-show="isAdmin">管理员</a>
            <a v-text="adminName"></a>
            <a v-show="isAdmin">已登录</a>
            <a
              style="margin-left:20px;"
              href="javascript:void(0);"
              class="float-right"
              v-on:click="logout()"
            >
              登出
              <span v-show="isAdmin">[已锁定]</span>
            </a>
          </div>
          <div class="cs-userInfo" v-show="isLogged && !showAdminHader">
            <a>欢迎，</a>
            <a v-text="username"></a>
            <a
              style="margin-left:20px;"
              href="javascript:void(0);"
              class="float-right"
              v-on:click="logoutUser()"
            >登出</a>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="cs-content">
      <div class="cs-content-body">
        <router-view
          @logged-event="onLogged()"
          @logout="logout"
          @page-changed-event="onPageChanged"
        />
      </div>
      <el-row class="cs-mobile-footer backgroud-black text-center hidden-sm-and-up">
        <el-col>
          <footer>
            <small>Powered by Speed Up Education Inc.</small>
          </footer>
        </el-col>
      </el-row>
    </div>
    <adminLogout
      :adminLogoutDialogVisible="adminLogoutDialogVisible"
      :showError="showAdminLogoutError"
      :errorMessage="adminLogoutErrorMessage"
      @onAdminLogout="onAdminLogout"
      @onCloseDialog="onCloseDialog"
    ></adminLogout>
  </div>
</template>

<style lang="scss" scoped>
.cs-userInfo {
  text-align: center;
  display: table-cell;
  height: 50px;
  vertical-align: middle;
  padding-left: 10px;
  float: right;
  a {
    line-height: 50px;
    color: white;
  }
}
.cs-logo-text-align {
  text-align: center;
}
</style>

<script>
import {
  getStore,
  isInRole,
  compileStr,
  setStore,
  clearAdminInStore,
  clearUserInStore,
  checkUserWechatPass
} from "./config/mUtils";
import global_ from "@/core/global";
import adminLogout from "./components/adminLogout";
import { userLogin, validateToken } from "../src/service/user.service";
import { getWeChatConfig } from "../src/service/common.service";


export default {
  name: "App",
  data() {
    return {
      isLogged: window.localStorage.getItem("amdin_user_name") !== null,
      adminName: window.localStorage.getItem("admin_user_name"),
      username: window.localStorage.getItem("user_name"),
      showAdminHader: !global_.bypassVideoAppointment,
      isAdmin: !global_.bypassVideoAppointment,
      adminLogoutDialogVisible: false,
      adminPassword: "",
      showAdminLogoutError: false,
      adminLogoutErrorMessage: "",
      bypassVideoAppointment: global_.bypassVideoAppointment
    };
  },
  components: {
    adminLogout
  },
  created() {
    let path = this.$route.path;

    if (path && path != "/" && path != "/login" && path != "/wechatResponse"){
      if (global_.wechatEnable){
        let isUserWechatPassed = checkUserWechatPass();
        if (!isUserWechatPassed){
          clearUserInStore();
          window.location.href = "/";
          return;
        }
        else {

        }
      }

      this.registerConnection();
    }

    // try {
    //     detectIncognito((rs) => {
    //       if (rs.isPrivate) {
    //           this.$alert('检测到您可能在无痕模式 (或称为\"隐私模式\") 下访问本网站. 在 \"无痕模式\" 或 \"隐私模式\" 下访问本网站可能会导致系统将当前浏览器识别为新的设备.<br />' +
    //           '如果登录提示设备数量达到上限, 请您联系客服解绑设备, 或在将浏览器切换到正常模式下访问本网站.', '提示', {
    //                   confirmButtonText: '确定',
    //                   dangerouslyUseHTMLString: true,
    //                   type: 'warning',
    //                   showClose: false,
    //                   callback: action => {

    //                   }
    //                 });

    //       }
    //     });

    // }catch(ex ){
    //   console.log("failed to check incognito mode");
    //   console.log(ex);
    // }

  },
  methods: {
    registerConnection(){
      let token = getStore("auth_token");
      let role = getStore("user_role");
      if (token && role) {
        validateToken().then(result => {
          if (result.success) {
            if (!global_.checkDevice){
              return;
            }
            global_.hubHandler.initialize((msg) => {
                this.$alert(msg, '下线提示', {
                  confirmButtonText: '确定',
                  type: 'warning',
                  showClose: false,
                  callback: action => {
                    location.href = "/";
                  }
                });

                return false;
              });
          }
        });
      }
    },
    loadRole() {
      this.isTeacher = isInRole(global_.roleType.teacher.name);
    },
    onLogged() {
      this.loadRole();
      this.checkLogin();
      this.setWeChatConfig();
      this.setBlobStorageConfig();
    },
    checkLogin(){
      this.username = window.localStorage.getItem("user_name");
      this.adminName = window.localStorage.getItem("admin_user_name");
      if (!this.bypassVideoAppointment){
         this.isLogged = !!this.adminName;
      }else{
        this.isLogged = !!this.username;
      }
    },
    onPageChanged() {
      if (!this.bypassVideoAppointment){
        this.showAdminHader =
          window.localStorage.getItem("show-admin-hader") == "true";
      }

      this.checkLogin();
    },
    logout() {
      this.openAdminLogoutDialog();
    },

    async adminlogout() {
      if (this.adminPassword) {
        let result = await userLogin(
          getStore("admin_user_name"),
          this.adminPassword,
          global_.roleType.admin.label
        );

        if (result) {
          if (!result.success) {
            this.showAdminLogoutError = true;
            this.adminLogoutErrorMessage = result.message;
            result;
          } else {
            this.adminLogoutDialogVisible = false;
            this.showAdminLogoutError = false;
            window.localStorage.clear();
            this.isLogged = false;
            this.$router.push("/");
          }
        }
      } else {
        this.showAdminLogoutError = true;
        this.adminLogoutErrorMessage = "请输入密码";
      }
    },

    logoutUser() {
      global_.hubHandler.unregister();

      clearUserInStore();
      if (this.bypassVideoAppointment){
        this.$router.push("/");
      }else{
        this.$router.push("/login");
      }
    },
    openAdminLogoutDialog() {
      this.showAdminLogoutError = false;
      this.adminLogoutDialogVisible = true;
    },
    onAdminLogout(password) {
      this.adminPassword = password;
      this.adminlogout();
    },
    onCloseDialog() {
      this.adminLogoutDialogVisible = false;
    },
    setBlobStorageConfig() {
      getBlobStorageConfig().then(result => {
        if (!!result && result.success) {
          let configureStr = compileStr(JSON.stringify(result.data));
          setStore("blobStorageConfig", configureStr);
        }
      });
    },
    setWeChatConfig() {
      getWeChatConfig().then(result => {
        if (!!result && result.success) {
          let configureStr = compileStr(JSON.stringify(result.data));
          setStore("weChatConfig", configureStr);
        }
      });
    },
  },
  watch: {
    username: function(v) {}
  },
  beforeRouteLeave(to, from, next) {}
};
</script>

<style lang="scss">
@import "./style/common";
@import "./style/navigator";
.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.3s;
}
.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}
.cs-header {
}
</style>




// WEBPACK FOOTER //
// src/App.vue